import { setQueryCache, teamAPI } from "@/utils"
import { useAPIResources } from "./query"

export function useTeams(params = {}) {
  const { data: { data: teams = [] } = {}, isPending } = useAPIResources(teamAPI, {
    ...params,
    // cache for 1 day
    ...setQueryCache(24 * 3600e3),
  })
  const teamsMap = new Map(teams.map((team) => [team.id, team]))

  return {
    teamsMap,
    isPending,
    findTeam: (id: string) => teamsMap.get(id),
    teams: teams.sort((a, b) => a.name.localeCompare(b.name)),
  }
}
